module.exports = __webpack_public_path__ + "img/track-performance.f093ce40.svg";